enum ContentStatus {
  NONE = 'none',
  CHANGE_REQUIRED = 'changeRequired',
  WORK_IN_PROGRESS = 'workInProgress',
  READY_TO_REVIEW = 'readyToReview',
  READY_TO_PUBLISH = 'readyToPublish',
}
export default ContentStatus;
